import { render, staticRenderFns } from "./PostCommentAnswer.vue?vue&type=template&id=2cb0e716&"
import script from "./PostCommentAnswer.vue?vue&type=script&lang=js&"
export * from "./PostCommentAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports